<template>
  <el-select
    size="small"
    v-model="value"
    :placeholder="`${$t(`${placeholder}`)}`"
    :filterable="filterable"
    :clearable="clearable"
    popper-class="select-tree"
    @visible-change="visibleSelectChange"
    ref="selectRef"
    @clear="$emit('change', null)"
  >
    <el-option
      :label="selectName"
      :value="value"
      :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
    >
      <el-tree
        :props="treeProps"
        class="max-h-274px overflow-x-hidden options-tree"
        ref="treeRef"
        node-key="id"
        highlight-current
        :data="optionList"
        @node-click="treeNodeClick"
        :expand-on-click-node="false"
        :default-expanded-keys="defaultExpandedKeys"
      ></el-tree>
    </el-option>
  </el-select>
</template>

<script>
import { find } from 'lodash'
import { treeToOneArray } from '@/assets/js/common/common'

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    treeProps: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          children: 'children',
        }
      },
    },
    optionList: {
      type: Array,
      default: () => {
        return []
      },
    },
    nodeKey: {
      type: String,
      default: 'id',
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultExpandedKeys: [],
      flattenOptionList: [],
    }
  },
  computed: {
    selectName() {
      return (
        find(this.flattenOptionList, (item) => {
          return item[this.nodeKey] === this.value
        })?.[this.treeProps.label] || ''
      )
    },
  },
  watch: {
    optionList: {
      immediate: true,
      handler(val) {
        this.flattenOptionList = treeToOneArray(val, this.treeProps.children)
      },
    },
  },
  methods: {
    visibleSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.treeRef.setCurrentKey(this.value) // 设置选中元素
          this.defaultExpandedKeys = [this.value]
        } else {
          const nodeDatas = this.$refs.treeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    treeNodeClick(node) {
      this.$emit('change', node[this.nodeKey])
      this.$refs.selectRef.blur()
    },
  },
}
</script>

<style lang="scss" scoped>
.options-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss">
.select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
